import { useTheme } from '../contexts/ThemeContext';
import { useLocation } from 'react-router-dom';

const LIGHT_THEME_ROUTES: string[] = [
  '/login',
  '/signup',
  '/forgot-password',
  '/reset-password',
  '/verify-email',
  '/magic-link/verify'
];

interface ThemedContainerProps {
  children: React.ReactNode;
}

function ThemedContainer({ children }: ThemedContainerProps): React.ReactElement {
  const { theme, isDark } = useTheme();
  const location = useLocation();
  
  const isLightThemeRoute = LIGHT_THEME_ROUTES.some(
    (route: string) => location.pathname === route || location.pathname.startsWith(route + '/')
  );
  
  if (isLightThemeRoute) {
    return (
      <div style={{ minHeight: '100vh' }}>
        {children}
      </div>
    );
  }
  
  return (
    <div 
      className={`${theme}-theme min-h-screen transition-colors duration-300 ${
        isDark 
          ? 'bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950' 
          : 'bg-gray-50'
      }`}
      style={{ minHeight: '100vh' }}
    >
      {children}
    </div>
  );
}

export default ThemedContainer;
